import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Convertisseur de litres";
const DESCRIPTION =
  "Convertisseur de litres pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "convertisseur de litres, calculatrice convertisseur de litres, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/liter-converter";
function LiterConverter() {
  const [liters, setLiters] = useState("");
  const [results, setResults] = useState({});
  const [error, setError] = useState("");

  const conversions = {
    "Millilitres": 1000,
    "Gallons US": 0.264172,
    "Gallons Impériaux": 0.219969,
    "Pintes US": 2.11338,
    "Onces US": 33.814
  };

  const handleCalculate = () => {
    try {
      const litre_val = parseFloat(liters);
      if (isNaN(litre_val) || litre_val < 0) {
        setError("Veuillez entrer une valeur valide");
        setResults({});
        return;
      }
      const converted = {};
      Object.keys(conversions).forEach(unit => {
        converted[unit] = (litre_val * conversions[unit]).toFixed(2);
      });
      setResults(converted);
      setError("");
    } catch (err) {
      setError("Erreur de conversion");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Le <strong>litre (L)</strong> est l'unité de volume la plus utilisée au quotidien pour mesurer les liquides
                  comme l'eau, le lait, l'essence ou les médicaments. Ce convertisseur vous permet de transformer
                  instantanément des litres en millilitres, gallons, pintes et onces, que vous soyez en cuisine,
                  en voyage ou en sciences.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Litres:</label>
                    <input
                      type="number"
                      value={liters}
                      onChange={(e) => setLiters(e.target.value)}
                      className="form-control"
                      placeholder="Entrez les litres"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Convertir
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {Object.keys(results).length > 0 && (
                  <div>
                    {Object.keys(results).map(unit => (
                      <p key={unit} className="p-3 mb-2 bg-success text-white">
                        {results[unit]} {unit}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Tableau de conversion des litres</h3>
                    </div>
                    <div className="info-section-body">
                      <p>Référence rapide des conversions depuis 1 litre :</p>
                      <ul>
                        <li>1 L = <strong>1 000 mL</strong> (millilitres)</li>
                        <li>1 L = <strong>1 000 cm³</strong> (centimètres cubes)</li>
                        <li>1 L ≈ <strong>0,264</strong> gallon US</li>
                        <li>1 L ≈ <strong>0,220</strong> gallon impérial</li>
                        <li>1 L ≈ <strong>2,113</strong> pintes US</li>
                        <li>1 L ≈ <strong>33,814</strong> onces liquides US</li>
                        <li>1 m³ = <strong>1 000 L</strong></li>
                      </ul>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Exemples pratiques de conversion</h3>
                    </div>
                    <div className="info-section-body">
                      <ul>
                        <li>Une bouteille d'eau de <strong>500 mL</strong> = 0,5 L</li>
                        <li>Un réservoir de voiture de <strong>50 L</strong> ≈ 13,2 gallons US</li>
                        <li>Une recette demandant <strong>1 pinte US</strong> ≈ 0,473 L</li>
                        <li>Un seau de <strong>10 L</strong> = 10 000 mL</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default LiterConverter;
